export default __webpack_public_path__ + "static/media/Listing.3a329e82.svg";